import React from 'react';
import { ConfigClientType } from './types/ConfigClientType';
import { IconCloseMenu } from './common/svgicons/CloseMenu';
import { getTranslation } from '../constants/languages';

type CloseMenuButtonProps = {
    iimclient: ConfigClientType;
    toggleMenu: Function;
};

const Translations = {
  lang_no: 'Lukk panelet for kundeservice',
  lang_se: 'Stäng kundtjänstalternativ',
  lang_dk: 'Luk kundeservicefunktioner',
  lang_fi: 'Sulje asiakaspalvelun vaihtoehdot',
  lang_en: 'Close customer service options'
}

const CloseMenuButton = ({ iimclient, toggleMenu }: CloseMenuButtonProps) => {
  const { lang } = iimclient;
  const translation = getTranslation(lang, Translations);
  
  const handleClick = () => toggleMenu('close')
  const handleKeyDown = ({ keyCode }) => (keyCode === 13 || keyCode === 32) && toggleMenu('close')

  return (
    <div
      className="content-button action cp-close-button"
      tabIndex={0}
      role="menuitem"
      aria-label={translation}
      onClick={handleClick}
      onKeyDown={handleKeyDown}>
      <IconCloseMenu width="24px" height="24px" />
    </div>
  );
};

export default CloseMenuButton;
